import "./style.css";

import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { cmsBlockActionDispatch } from "../../store/cmsBlock/actions";
import { selectTermsAndConditionsSelector } from "../../store/cmsBlock/selector";
import { cmsBlockKeys } from "../../utils/constants";
import { TermsAndConditionsLoader } from "../../components/loaders/productLoaders";
import PageLayout from "../pageLayout";
import cmsBlockService from "../../services/cmsBlockService";

const NexisTerms = () => {
  const [loading, setLoading] = useState(true);
  const termsCMSPage = useAppSelector(selectTermsAndConditionsSelector);

  const { setTermsAndConditions } = cmsBlockActionDispatch(useAppDispatch());

  useEffect(() => {
    cmsBlockService.setCMSPages(
      cmsBlockKeys.termsConditions,
      setTermsAndConditions,
      () => setLoading(false)
    );
  }, []);

  const extractedText = termsCMSPage?.content
    ? new DOMParser().parseFromString(termsCMSPage?.content, "text/html").body
        .textContent || ""
    : "";

  return (
    <PageLayout>
      {!loading ? (
        <>
          <section className="!px-16 w-full">
            <div className="container ln-terms-container mx-auto py-16 pt-6 md:pt-10">
              <div dangerouslySetInnerHTML={{ __html: extractedText }} />
            </div>
          </section>
        </>
      ) : (
        <TermsAndConditionsLoader />
      )}
    </PageLayout>
  );
};

export default NexisTerms;
